import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MapConfigService, injectMapFeatureConfig } from '@navfleet/client/map/domain/data-access';
import { MAP_FEATURE_CONFIG, MapFeatureConfig, MapFeatureContribution } from '@navfleet/client/map/domain/models';
import { MAP_EXPAND_MAP_FEATURE_KEY, overrideMapExpandMapConfig } from '@navfleet/client/map/expand-map/domain/models';
import { Observable } from 'rxjs';

// Re-exported from the models lib, so map configs in models and ui libs can use them
export { MAP_EXPAND_MAP_FEATURE_KEY, overrideMapExpandMapConfig };

export const injectMapExpandMapConfig = (): Observable<MapFeatureConfig> =>
    injectMapFeatureConfig<MapFeatureConfig>(MAP_EXPAND_MAP_FEATURE_KEY);

/**
 * Pure variant for the rare case where you already hold a
 * MapConfigService reference (e.g. in a non-injection context).
 */
export const getMapExpandMapConfig = (service: MapConfigService): Observable<MapFeatureConfig> =>
    service.getFeatureConfig(MAP_EXPAND_MAP_FEATURE_KEY) as Observable<MapFeatureConfig>;

/* ──────────────────────────────────────────────────────────────
 * RUNTIME CONTRIBUTION — multi-provider with default config
 * ────────────────────────────────────────────────────────────── */
const DEFAULT_EXPAND_MAP: MapFeatureConfig = {
    enabled: true,
};

export function provideMapExpandMapFeature(overrides: Partial<MapFeatureConfig> = {}): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: MAP_FEATURE_CONFIG,
            multi: true,
            useValue: {
                [MAP_EXPAND_MAP_FEATURE_KEY]: { ...DEFAULT_EXPAND_MAP, ...overrides },
            } satisfies MapFeatureContribution,
        },
    ]);
}
